import { GameConstants } from "../GameConstants";
import { GameVars } from "../GameVars";
import { AudioManager } from "../AudioManager";

export class Boot extends Phaser.State {

    public static currentInstance: Boot;

    public static bootedInWrongOrientation: boolean;

    public static onYandexFullscreenChanged() {

        const aspectRatio = GameVars.gameHeight / GameConstants.GAME_WIDTH;

        if (Boot.currentInstance.game.device.desktop) {

            let widthLimit = Math.min(screen.height / aspectRatio, window.innerHeight / aspectRatio);
            const heightLimit = Math.min(screen.height, window.innerHeight);

            Boot.currentInstance.game.scale.minWidth = widthLimit;
            Boot.currentInstance.game.scale.minHeight = heightLimit;

            Boot.currentInstance.game.scale.maxWidth = widthLimit;
            Boot.currentInstance.game.scale.maxHeight = heightLimit;
            Boot.setScaleFactor(Boot.currentInstance.game.scale.maxWidth / Boot.currentInstance.game.scale.maxHeight);

        } else {

            Boot.currentInstance.game.scale.maxWidth = window.innerWidth;
            Boot.currentInstance.game.scale.maxHeight = Math.max(screen.height, window.innerHeight);
            Boot.setScaleFactor();
        }

        Boot.currentInstance.game.scale.refresh();
    }

    public static onFullScreenChange(): void {

        Boot.setScaleFactor(screen.width / screen.height);
        Boot.currentInstance.game.scale.refresh();
    }

    public static onOrientationChange(): void {

        if (!Boot.currentInstance) {
            return;
        }

        Boot.currentInstance.game.time.events.add(200, function (): void {
            
            if (Boot.bootedInWrongOrientation && window.innerHeight < window.innerWidth) {
                Boot.currentInstance.game.state.restart(true, false);
            }
            
        }, this);
    }

    public static enterIncorrectOrientation(): void {

        document.getElementById("orientation").style.display = "block";
        document.getElementById("content").style.display = "none";
        Boot.currentInstance.game.paused = true;
    }

    public static leaveIncorrectOrientation(): void {

        document.getElementById("orientation").style.display = "none";
        document.getElementById("content").style.display = "block";
        Boot.currentInstance.game.paused = false;
    }

    private static setScaleFactor(aspectRatioOverride?: number): void {

        let aspectRatio = aspectRatioOverride || window.innerWidth / window.innerHeight;

        GameVars.scaleX = (GameConstants.GAME_WIDTH / GameVars.gameHeight) / aspectRatio;
    }

    public init(): void {

        Boot.currentInstance = this;

        this.input.maxPointers = 1;

        // the game freezes when losing focus
        this.game.stage.disableVisibilityChange = false;

        // due to the android stock browser problem
        this.game.stage.backgroundColor = "#000000";

        if (this.game.device.desktop) {

            GameVars.scaleX = 1;

            this.game.scale.scaleMode = Phaser.ScaleManager.SHOW_ALL;
            this.game.scale.pageAlignHorizontally = true;

        } else {

            this.game.scale.scaleMode = Phaser.ScaleManager.EXACT_FIT;

            if (GameConstants.SPONSOR !== GameConstants.YANDEX) {
                if (this.game.scale.compatibility.supportsFullScreen) {
                    this.game.scale.fullScreenScaleMode = Phaser.ScaleManager.EXACT_FIT;
                    this.game.scale.onFullScreenChange.add(Boot.onFullScreenChange, this);
                } else {
                    console.log("Device does not support fullscreen");
                }
            }

            Boot.setScaleFactor();

            this.game.scale.pageAlignVertically = true;

            this.game.scale.forceOrientation(true, false);

            window.onresize = Boot.onOrientationChange;
            window.onorientationchange = Boot.onOrientationChange;
            this.game.scale.onOrientationChange.add(Boot.onOrientationChange, this);
            this.game.scale.enterIncorrectOrientation.add(Boot.enterIncorrectOrientation, Boot);
            this.game.scale.leaveIncorrectOrientation.add(Boot.leaveIncorrectOrientation, Boot);

            Boot.bootedInWrongOrientation = window.innerHeight > window.innerWidth ? true : false;
        }

        if (GameConstants.SPONSOR === GameConstants.YANDEX) {
            window.onresize = Boot.onYandexFullscreenChanged;
            Boot.onYandexFullscreenChanged();
        }

        GameVars.getInstance().init();

        GameVars.language = GameConstants.LANGUAGE_ENGLISH;

        // to measure the fps
        if (GameConstants.DEVELOPMENT) {
            this.game.time.advancedTiming = true;
        }

        if (this.game.device.desktop) {

            this.game.onBlur.add(function (): void {
                AudioManager.getInstance().mute();
            }, this);

            this.game.onFocus.add(function (): void {
                AudioManager.getInstance().unmute();
            }, this);

        } else {

            this.game.onPause.add(function (): void {
                AudioManager.getInstance().mute();
            }, this);

            this.game.onResume.add(function (): void {
                AudioManager.getInstance().unmute();
            }, this);
        }
    }

    public preload(): void {

        if (GameConstants.SPONSOR === GameConstants.SOLITAIRE_KOSTENLOS) {
            this.load.image("solitaire-kostenlos-logo", "assets/solitairekostenlos-logo.png");
        }

        this.load.image("game-logo", "assets/game-logo.png");
        this.load.image("blurred-stage", "assets/blurred-stage.png");

        // fonts
        this.load.bitmapFont("times-roman", "assets/fonts/times-roman.png", "assets/fonts/times-roman.xml");

        // temporalmente
        this.load.bitmapFont("marker-felt", "assets/fonts/marker-felt.png", "assets/fonts/marker-felt.xml");
    }

    public create(): void {

        var that = this;
        PokiSDK.init().then(
            () => {
                console.log("Poki SDK successfully initialized");
                // your code to continue to game
                that.game.state.start("PreLoader", true, false);
            }   
        ).catch(
            () => {
                console.log("Initialized, but the user likely has adblock");
                // your code to continue to game
                that.game.state.start("PreLoader", true, false);
            }   
        );
        PokiSDK.setDebug(false);
    }
}

